import $ from "jquery";
window.jQuery = $;
window.$ = $;

// import { GraphQLClient } from 'graphql-request'

// const client = new GraphQLClient('https://matthias-deckx.fontdue.com/graphql', {
//   headers: {
//     Authorization: 'Bearer YOUR_AUTH_TOKEN',
//   },
// });

import "lazysizes";

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

// import { tns } from "tiny-slider/src/tiny-slider";
// window.tns = tns;

import Swiper, { Autoplay, EffectFade } from "swiper";

import Headroom from "headroom.js/dist/headroom.js";
window.Headroom = Headroom;

import { intro } from "./components/intro";
import { header } from "./components/header";
import { nav } from "./components/nav";
import { overlay } from "./components/overlay";
// import { toggleMode } from "./components/toggle-mode";
import { carousel } from "./components/carousel";
import { typefaceTester } from "./components/typeface-tester";

// import { collapsibleSections } from "./components/collapsible-sections";
// import { toggleSections } from "./components/toggle-sections";

window.main = window.main || {};

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;
let isOverlayToggled = false;
let isPanelToggled = false;
let introRan = false;
let sliderRan = false;

let swiper;
let cssSpaceBetween = getComputedStyle(document.documentElement).getPropertyValue("--padding-slider");
let spaceBetween = parseInt(cssSpaceBetween, 10);

let slidesPerView = 1.65;
if (window.innerWidth < 960) {
  slidesPerView = 1.4;
}

function initSwiper() {
  const sliderdesktop = document.querySelector(".swiper-container");
  if (typeof sliderdesktop != "undefined" && sliderdesktop != null) {
    swiper = new Swiper(".swiper-container", {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      centeredSlides: true,
      loop: true,
      slideToClickedSlide: true,
      grabCursor: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
    });
    sliderRan = true;
  }



}

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

  if (sliderRan == true) {
    swiper.destroy();
    sliderRan = false;
  }
}

function setupPlugins() {
  function initSwup() {
    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#swup"],
      plugins: [
        new SwupPreloadPlugin(),
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });
  }

  initSwup();
}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {
  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  intro(introRan, isHomepage);
  header(isTouchDevice);
  nav(isNavToggled, isPanelToggled);
  overlay(isOverlayToggled);
  initSwiper();
  carousel();
  typefaceTester();
  // toggleSections();
}

function init() {
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  intro(introRan, isHomepage);
  header(isTouchDevice);
  nav(isNavToggled);
  overlay(isOverlayToggled);
  initSwiper();
  carousel();
  typefaceTester();
  // toggleMode();
}

checks();
setupPlugins();
init();
